import { ProjectListPage } from '@/pages/projects/ProjectListPage';
import { ROUTES } from '@/constants/routes';

export default function DevProjectsPage() {
  return (
    <ProjectListPage
      source="dev"
      backRoute="/admin"
      detailRoutePrefix={ROUTES.DEV_PROJECTS}
      titleKey="projects.devTitle"
    />
  );
}
